// need to be referenced in client+pipedomain
export var LineageVertexLabelType;
(function (LineageVertexLabelType) {
    LineageVertexLabelType["INCENTIVES_TABLE"] = "incentives-table";
    LineageVertexLabelType["INCENTIVES_EXPORT"] = "incentives-export";
})(LineageVertexLabelType || (LineageVertexLabelType = {}));
export var LineageEdgeLabelType;
(function (LineageEdgeLabelType) {
    LineageEdgeLabelType["INCENTIVES_TABLE_TO_EXPORT"] = "incentives-table-to-export";
    LineageEdgeLabelType["INCENTIVES_IMPORT_TO_EXPORT"] = "incentives-import-to-export";
})(LineageEdgeLabelType || (LineageEdgeLabelType = {}));
//# sourceMappingURL=lineage.js.map